import React from 'react';
import type { INewsItem } from '../../../interfaces/News.interface';
import type { NewsAEMImages, NewsAEMTimestampLabels } from '../../../interfaces/NewsAEM.interface';
import HorizontalNewsCard from './HorizontalNewsCard';
import VerticalNewsCard from './VerticalNewsCard';
import CompactNewsCard from './CompactNewsCard';

interface NewsListProps {
  newsItems?: INewsItem[] | null;
  variant?: 'horizontal' | 'vertical' | 'compact';
  showCompanies?: boolean;
  showSource?: boolean;
  onNewsSelect?: (newsId: string) => void;
  className?: string;
  aemImages?: NewsAEMImages;
  timestampLabels?: NewsAEMTimestampLabels;
}

/**
 * Reusable component for rendering a list of news items
 */
const NewsList: React.FC<NewsListProps> = ({
  newsItems,
  variant = 'horizontal',
  showCompanies = true,
  showSource = false,
  onNewsSelect,
  className = '',
  aemImages,
  timestampLabels,
}) => {
  const safeItems = Array.isArray(newsItems) ? newsItems : [];

  if (safeItems.length === 0) {
    return null;
  }

  let CardComponent = HorizontalNewsCard;
  if (variant === 'vertical') {
    CardComponent = VerticalNewsCard;
  } else if (variant === 'compact') {
    CardComponent = CompactNewsCard;
  }

  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {safeItems.map((item) => (
        <CardComponent
          key={item.id}
          newsItem={item}
          onClick={onNewsSelect}
          showCompanies={showCompanies}
          showSource={showSource}
          aemImages={aemImages}
          timestampLabels={timestampLabels}
          className={className}
        />
      ))}
    </div>
  );
};

export default NewsList;

